import React from 'react';
export function IntroSection() {
  return <section className="bg-cream px-5 py-20 md:py-28" aria-labelledby="intro-title" data-id="element-148" data-mp="3aawl0bpqlrli">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[1fr_1.15fr] lg:gap-16" data-id="element-149" data-mp="15325x0dpgr0h">
        <div data-id="element-150" data-mp="101l3v1jhiyib">
          <div className="h-px w-12 bg-rose" aria-hidden="true" data-id="element-151" data-mp="10133bspshy4l" />
          <h2 id="intro-title" className="mt-6 font-serif text-3xl uppercase leading-[1.15] text-ink md:text-5xl" data-id="element-152" data-mp="v4cmh365uyi4">
            No tenés que aprender todo <span className="text-rose-dark" data-id="element-153" data-mp="q5rnf72nakv9">de golpe.</span>
          </h2>
        </div>
        <div className="lg:pt-10" data-id="element-154" data-mp="lc6y03f4az7o">
          <p className="font-serif text-xl italic leading-relaxed text-ink md:text-2xl" data-id="element-155" data-mp="hc66bh30crio">
            El primer baño. Las dudas sobre la lactancia. Las noches interrumpidas. Los controles médicos. Los cambios en tu cuerpo. La organización de la casa.
          </p>
          <p className="mt-6 text-lg font-semibold text-sage-dark" data-id="element-156" data-mp="7dh1oq04h3kd">Son muchas cosas nuevas en muy poco tiempo.</p>
          <p className="mt-4 text-lg leading-relaxed text-ink-muted" data-id="element-157" data-mp="2gyyhukfxda5">
            Por eso creamos un kit que reúne información y herramientas para que puedas consultar lo que necesitás, cuando lo necesitás.
          </p>
        </div>
      </div>
    </section>;
}